export default "__VITE_ASSET__C1tPBtcH__"